import React from 'react';
import _ from 'lodash';

export const convertToHtml = (template: string | null, options: any) => {
    if(!template) return null;
    const tag = {
        open: '<%=',
        close: '%>',
    };
    const regexp = new RegExp(`(${tag.open}.*?${tag.close})`, 'g')
    const onlyLetters = new RegExp(/[^A-Za-z]/, 'g')

    const getValue = item => isVariable(item) ?
        _.get(options, item.replace(onlyLetters, ''), null) : item

    const isVariable = item => _.size(item.match(regexp))
    const data = _.chain(template)
        .split('\n')
        .map(template => _.split(template, regexp))
        .map(row => _.map(row, getValue))
        .value()
    return (
        _.map(data, (row, k) => (
            <p key={k}>
                {
                    _.map(row, (item, i) => (
                        <span key={i}>{ item }</span>
                    ))
                }
            </p>
        ))
    )

};

export const isValidEmail = (email: string) => {
    const regexp = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
    return email.match(regexp)
}